<template>
  <table>
    <data-table-header
      v-if="headerSlotEmpty"
      :headers="headers"
      :color="color"
      :fontColor="fontColor"
      @headerClick="handleHeaderClick"
    >
      <slot name="header-item"></slot>
    </data-table-header>
    <slot name="header" :headers="headers"></slot>
    <tbody v-if="bodySlotEmpty">
      <template v-if="rowSlotEmpty">
        <data-table-row
          v-for="(item, index) in items"
          :key="index"
          :item="item"
          :headers="headers"
          :color="rowColor"
          :fontColor="rowFontColor"
        >
        </data-table-row>
      </template>
      <slot :items="items" :headers="headers" name="row"></slot>
    </tbody>
    <slot name="tbody" :items="items" :headers="headers"> </slot>
  </table>
</template>

<script>
import DataTableHeader from "./DataTableHeader.vue";
import DataTableRow from "./DataTableRow.vue";

export default {
  components: {
    DataTableHeader,
    DataTableRow,
  },
  props: {
    headers: Array,
    headersClass: String,
    items: Array,
    color: {
      type: String,
    },
    fontColor: {
      type: String,
    },


    rowColor: {
      type: String,
      default: "white",
    },
    rowFontColor: {
      type: String,
      default: "dark--text",
    },
  },
  computed: {
    headerSlotEmpty() {
      return !this.isSlotFilled("header");
    },
    bodySlotEmpty() {
      return !this.isSlotFilled("tbody");
    },
    rowSlotEmpty() {
      return !this.isSlotFilled("row");
    },
  },
  methods: {
    isSlotFilled(name, type = "function") {
      return typeof this.$scopedSlots[name] === type;
    },
    // handleEvents(...args) {
    //   this.$emit()
    // },
    handleHeaderClick(headerItem) {
      if ("callback" in headerItem) {
        headerItem.callback(this.items);
      }
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 7px;
}

th {
  font-weight: 500;
  color: rgb(244, 244, 244);
}

.sort-icon {
  opacity: 0;
}
.selected-sort-icon {
  opacity: 1;
}
.rotate180deg {
  transform: rotate(180deg);
}

.header-row {
  height: 45px;
}

.table-body >>> tr {
  background: white;
  height: 50px;
}
.table-cell:first-child {
  padding-left: 10px;
}
.table-cell:last-child {
  padding-right: 10px;
}
/* .table-body > tr:hover { */
/* filter: brightness(97.5%); */
/* } */
.align-center {
  text-align: center;
}
.align-left {
  text-align: left;
}
.align-right {
  text-align: right;
}
</style>